import { Auth } from '@mint-sdk/api-auth';

import type { RoleType } from '../../api/roles/roles.types.js';

function megabytesToBytes(megabytes: number): number {
  const bytesInMegabyte = 1024 * 1024;
  return megabytes * bytesInMegabyte;
}
const maxSizeMB = 2;

export const maxSizeBytes = megabytesToBytes(maxSizeMB);

// compare two number arrays
export const isEqual = (base: number[], compare?: number[]): boolean =>
  base.length === compare?.length &&
  base.every((baseValue) =>
    compare.some((compareValue) => compareValue === baseValue),
  );

// remove agency role if user isn't agency user
export const filterAgencyRoles = (
  list: RoleType[] | Auth.RoleItemV2[],
  isAgencyUser: boolean,
): RoleType[] | Auth.RoleItemV2[] => {
  if (isAgencyUser) {
    return list;
  }
  return list.filter(
    (role) => role.roleType !== 'agency_client_role_type',
  ) as typeof list;
};
